var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#button_current_position_marker{width:40px;height:40px;border-radius:80%;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.3);box-shadow:0 2px 6px rgba(0,0,0,.3);background:url(" + escape(require("../../../assets/image/gps-location.svg")) + "),-webkit-gradient(linear,left top,left bottom,from(#fa800a),to(#f60000));background:url(" + escape(require("../../../assets/image/gps-location.svg")) + "),linear-gradient(#fa800a,#f60000);background:url(" + escape(require("../../../assets/image/gps-location.svg")) + "),-webkit-linear-gradient(#fa800a,#f60000);margin-bottom:150px;margin-right:20px;background-size:100% 100%}", ""]);

// exports
